module.exports = '<style>body { margin: 0;}</style><div id="canvasTarget" style="width: 100%; height: 100%;"></div>';
